import type { AfterResponseHook } from 'ky';
import { isServer } from '../../utils';
import isNative from '../../../native/isNative';
import { AUTH_ENDPOINT_KEY, LOGOUT_URL } from '../../../../auth/const';
import type { HookGetterArgs } from '../types';
import { redirectOn401 } from '../../../handle401';

const getPathNameFromUrl = (url: string) => {
  const urlObj = new URL(url);
  return urlObj.pathname;
};

/**
 * upon logout, multiple api calls return 401, but we need to redirect only once. Otherwise, the confirmation popup will be shown multiple times.
 */
let hasRedirectedToLogoutPage = false;

export const handleLogout = ({ options }: HookGetterArgs): AfterResponseHook => {
  const handleLogoutHook: AfterResponseHook = (req, opts, response) => {
    if (
      redirectOn401 &&
      response.status === 401 &&
      // req path doesn't start with /auth
      !getPathNameFromUrl(req.url).startsWith(AUTH_ENDPOINT_KEY) &&
      !isServer() &&
      !isNative() &&
      // disable auto redirect for cors domain
      !options.credentials &&
      !hasRedirectedToLogoutPage
    ) {
      // redirect to login page
      hasRedirectedToLogoutPage = true;
      window.location.href = LOGOUT_URL;
    }

    if (response.ok && response.redirected) {
      // Extract the Location header from the response
      // const redirectUrl = response.headers.get('Location');
      // Manually follow the redirect
      window.location.href = response.url;
    }
  };
  return handleLogoutHook;
};
